module.exports = __webpack_public_path__ + "img/carlos_assustado.89a52a12.jpg";